var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stopwatch-skeleton"},[_vm._t("prepend"),_c('skeleton',{attrs:{"width":_vm.width,"height":_vm.height}}),_c('span',[_vm._v(":")]),_c('skeleton',{attrs:{"width":_vm.width,"height":_vm.height}}),_c('span',[_vm._v(":")]),_c('skeleton',{attrs:{"width":_vm.width,"height":_vm.height}}),_vm._t("append")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }